import React from 'react';
import { FormattedMessage } from 'react-intl';

const AlertInfo = props => {
    const { id = 'common.no_text', skipIntl = false, textReplacements = {} } = props;

    return (
        <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
            <div className="usa-alert__body gi-alert__info__body">
                <p className="usa-alert__text gi-alert__info__text">
                    {skipIntl ? (
                        id
                    ) : (
                        <FormattedMessage
                            id={id}
                            values={{
                                ...textReplacements,
                                strong: function (chunks) {
                                    return <strong>{chunks}</strong>;
                                },
                                i: function (chunks) {
                                    return <i>{chunks}</i>;
                                },
                                br: <br />,
                            }}
                        />
                    )}
                </p>
            </div>
        </div>
    );
};

export default AlertInfo;
